import React from 'react';
import {Person, Container} from '../../components';

const PersonPage = () =>
<>
<Container>
<Person />
</Container>
</>;

export default PersonPage;